import { useState } from "react";
import { Send, Loader2, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";
import { finApi, apiErr } from "../api";
import { Button } from "../../components/ui/button";

const LABEL = { cleared: "معتمدة من الهيئة (Cleared)", reported: "مُبلّغ عنها للهيئة (Reported)", rejected: "مرفوضة من الهيئة", error: "تعذر الإرسال" };

export const ZatcaSubmission = ({ d, onDone, canPost }) => {
  const [busy, setBusy] = useState(false);
  const s = d.zatca?.submission;
  const ok = s && ["cleared", "reported"].includes(s.status);
  const send = async () => {
    setBusy(true);
    try { const r = await finApi.zatcaSubmit(d.id); (["cleared", "reported"].includes(r.status) ? toast.success : toast.error)(LABEL[r.status]); onDone?.(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 border-t border-emerald-200/70 pt-3" data-testid="fin-zatca-submission">
      {s && (
        <div className={`mb-2 rounded-lg p-2 text-[11px] ${ok ? "bg-emerald-100/70 text-emerald-900" : "bg-rose-50 text-rose-700"}`}>
          <div className="flex items-center gap-1 font-bold" data-testid="fin-zatca-submission-status">{ok ? <CheckCircle2 className="h-3.5 w-3.5" /> : <XCircle className="h-3.5 w-3.5" />}{LABEL[s.status] || s.status} · {s.environment} · {s.at?.slice(0, 16).replace("T", " ")}</div>
          {[...(s.errors || []), ...(s.warnings || [])].length > 0 && <ul className="mt-1 list-disc space-y-0.5 pe-4" data-testid="fin-zatca-submission-msgs">{[...(s.errors || []), ...(s.warnings || [])].slice(0, 6).map((m) => <li key={m} className="break-words">{m}</li>)}</ul>}
        </div>
      )}
      {!ok && canPost && (
        <Button size="sm" onClick={send} disabled={busy} className="gap-1.5 bg-slate-900 hover:bg-slate-800" data-testid="fin-zatca-submit-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} {s ? "إعادة الإرسال للهيئة" : d.invoice_kind === "simplified" ? "إبلاغ الهيئة (Reporting)" : "طلب الاعتماد (Clearance)"}
        </Button>
      )}
    </div>
  );
};
